import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'

export default function NexusNodeTypesAddresComponent({
  handleInnerFormChange, selectedNexusNodes, NexusZoneId, NexusNodeType, GlobalNexusZone
}: any) {
  console.log(NexusZoneId, "NexusZoneId")
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="ContactPersonName"
              name="ContactPersonName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ContactPersonName',
                )
              }}
              type="text"
              value={selectedNexusNodes?.ContactPersonName}
            />
            <InputContainer
              label="ContactPhoneNumber"
              name="ContactPhoneNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ContactPhoneNumber',
                )
              }}
              type="text"
              value={selectedNexusNodes?.ContactPhoneNumber}
            />
            <InputContainer
              label="Address1"
              name="Address1"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Address1',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Address1}
            />
            <InputContainer
              label="Address2"
              name="Address2"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Address2',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Address2}
            />
            <InputContainer
              label="Citycode"
              name="Citycode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Citycode',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Citycode || ""}
            />
            <InputContainer
              label="Statecode"
              name="Statecode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Statecode',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Statecode || ""}
            />
            <InputContainer
              label="Lattitude"
              name="Lattitude"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Lattitude',
                )
              }}
              type="number"
              value={selectedNexusNodes?.Lattitude}
            />
            <InputContainer
              label="Longitude"
              name="Longitude"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Longitude',
                )
              }}
              type="number"
              value={selectedNexusNodes?.Longitude}
            />
            <InputContainer

              label="Effective From"
              name="EffectiveFromDateUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'EffectiveFromDateUtc'
                )
              }}
              type="date"
              value={selectedNexusNodes?.EffectiveFromDateUtc}
            />
              <InputContainer

              label="Effective To"
              name="EffectiveToDateUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'EffectiveToDateUtc'
                )
              }}
              type="date"
              value={selectedNexusNodes?.EffectiveToDateUtc}
            />
          </div>


        }
        expandedPanel="userInfo"
        headerTitle="Address"
      />
    </>
  )
}